import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import SettingsNav from './SettingsNav';
import { Settings as SettingsIcon } from 'lucide-react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../context/AuthContext';
import { useRole } from '../../context/RoleContext';
import RoleBadge from '../../components/RoleBadge';

const Settings = () => {
  const { profile } = useAuth();
  const { role } = useRole();
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    const loadCompanyName = async () => {
      const companyId = profile?.companyId;
      if (!companyId || !db) {
        setCompanyName('');
        return;
      }

      try {
        const companyRef = doc(db, 'companies', companyId);
        const snap = await getDoc(companyRef);
        setCompanyName(snap.exists() ? (snap.data()?.name || '') : '');
      } catch (e) {
        console.error('Failed to load company name:', e);
        setCompanyName('');
      }
    };

    loadCompanyName();
  }, [profile?.companyId]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header — compact on mobile */}
      <div className="bg-white border-b border-gray-200 px-4 py-3 lg:px-6 lg:py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <SettingsIcon className="h-6 w-6 lg:h-8 lg:w-8 text-primary shrink-0" />
            <div className="min-w-0">
              <h1 className="text-xl lg:text-3xl font-bold text-secondary truncate">Settings</h1>
              <p className="hidden lg:block text-muted-foreground">Manage your account, team, and application configuration.</p>
            </div>
          </div>

          {(companyName || role) && (
            <div className="text-right shrink-0">
              {companyName && (
                <p className="hidden sm:block text-sm font-semibold truncate max-w-[160px]" style={{ color: 'var(--cb-navy)' }}>
                  {companyName}
                </p>
              )}
              {role && <RoleBadge role={role} size="sm" />}
            </div>
          )}
        </div>
      </div>

      {/* Main Content Area with Left Nav
          Mobile: column flow — picker on top, content fills remaining width.
          Desktop: row flow — sidebar + content side-by-side (unchanged). */}
      <div className="flex flex-col lg:flex-row">
        {/* Nav — responsive: <lg renders mobile picker, >=lg renders sidebar */}
        <SettingsNav />

        {/* Right Content Area */}
        <div className="flex-1 p-4 lg:p-6 min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Settings;
